/* global axios */
/* eslint-disable class-methods-use-this */
import ApiClient from './ApiClient';

class RecurringMessagesAPI extends ApiClient {
  constructor() {
    super('recurring_messages', { accountScoped: true });
  }

  static getAccountId() {
    const { pathname } = window.location;
    const match = pathname.match(/accounts\/(\d+)/);
    return match ? match[1] : null;
  }

  getAll() {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.get(`/api/v1/accounts/${accountId}/recurring_messages`);
  }

  get(conversationId) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.get(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages`
    );
  }

  show(conversationId, id) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.get(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages/${id}`
    );
  }

  create(conversationId, recurringMessageObj) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages`,
      recurringMessageObj
    );
  }

  update(conversationId, id, recurringMessageObj) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.patch(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages/${id}`,
      recurringMessageObj
    );
  }

  delete(conversationId, id) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.delete(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages/${id}`
    );
  }

  pause(conversationId, id) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages/${id}/pause`
    );
  }

  resume(conversationId, id) {
    const accountId = RecurringMessagesAPI.getAccountId();
    return axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/recurring_messages/${id}/resume`
    );
  }
}

export default new RecurringMessagesAPI();
